import { Component } from "@angular/core";
import { NofeshService } from "../../nofesh.service";

@Component({
    moduleId:module.id,
    templateUrl: './home.component.html',
    providers: [NofeshService]

})

export class NofeshAdminHomeComponent{

    
}